module.exports = require("node:buffer");